import { render, staticRenderFns } from "./FileViewField.vue?vue&type=template&id=aae2f7f4&scoped=true&"
import script from "./FileViewField.vue?vue&type=script&lang=ts&"
export * from "./FileViewField.vue?vue&type=script&lang=ts&"
import style0 from "./FileViewField.vue?vue&type=style&index=0&id=aae2f7f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae2f7f4",
  null
  
)

export default component.exports